const routesCommon = [
  {
    path: "/homepage",
    name: "homepage",
    component: () => import("../views/Layout/homepage.vue"),
    hidden: true,
    meta: {
      title: "JoinMC",
      crumbs: "JoinMC",
      isLogin: false,
    },
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import("../views/Layout/demo.vue"),
    hidden: true,
    meta: {
      title: "route.test-cases",
      crumbs: "route.test-cases",
      isLogin: false,
    },
  },
  {
    path: "/cases",
    name: "cases",
    component: () => import("../views/Layout/cases.vue"),
    hidden: true,
    meta: {
      title: "route.cases",
      crumbs: "route.cases",
      isLogin: false,
    },
  },
  {
    path: "/u_ag",
    name: "userAgreement",
    component: () => import("../views/Layout/common/userAgreement.vue"),
    hidden: true,
    meta: {
      title: "route.user-agreement",
      crumbs: "route.user-agreement",
      isLogin: false,
    },
  },
  {
    path: "/p_po",
    name: "privacyPolicy",
    component: () => import("../views/Layout/common/privacyPolicy.vue"),
    hidden: true,
    meta: {
      title: "route.privacy-policy",
      crumbs: "route.privacy-policy",
      isLogin: false,
    },
  },
  {
    // JoinCompass AI 首页页脚使用独立协议页，避免改变 JoinMC 既有公开协议地址。
    path: "/joincompass/user-agreement",
    name: "joinCompassUserAgreement",
    component: () => import("../views/Layout/common/joinCompassUserAgreement.vue"),
    hidden: true,
    meta: {
      title: "route.user-agreement",
      crumbs: "route.user-agreement",
      isLogin: false,
    },
  },
  {
    // JoinCompass AI 首页页脚使用独立隐私政策页，内容与 JoinMC 版本隔离维护。
    path: "/joincompass/privacy-policy",
    name: "joinCompassPrivacyPolicy",
    component: () => import("../views/Layout/common/joinCompassPrivacyPolicy.vue"),
    hidden: true,
    meta: {
      title: "route.privacy-policy",
      crumbs: "route.privacy-policy",
      isLogin: false,
    },
  },
  {
    path: "/redirectlogin",
    name: "redirectlogin",
    hidden: true,
    component: () => import("../views/login/redirect.vue"),
    meta: {
      isLogin: false,
    },
  },
  {
    path: "/404",
    name: "404",
    hidden: true,
    component: () => import("../views/Layout/common/404.vue"),
    meta: {
      title: "404",
      crumbs: "404",
      isLogin: false,
    },
  },
  {
    // 支付宝支付页面
    path: "/alipay",
    name: "alipay",
    hidden: true,
    component: () => import("../components/Alipay.vue"),
    meta: {
      title: "route.alipay",
      crumbs: "route.alipay",
      isLogin: true,
    },
  },
  {
    path: "/x/authResponse",
    name: "xAuthResponse",
    component: () => import("@/components/PlatformPagesSelect/XAuthResponse.vue"),
    meta: {
      title: "route.x-auth",
      crumbs: "route.x-auth-crumb",
      isLogin: true,
    },
  },
  {
    path: "/tiktok/authResponse",
    name: "TTAuthResponse",
    component: () => import("@/components/PlatformPagesSelect/TTAuthResponse.vue"),
    meta: {
      title: "route.tiktok-auth",
      crumbs: "route.tiktok-auth-crumb",
      isLogin: true,
    },
  },
  {
    path: "/vk/authResponse",
    name: "VKAuthResponse",
    component: () => import("@/components/PlatformPagesSelect/VKAuthResponse.vue"),
    meta: {
      title: "route.vk-auth",
      crumbs: "route.vk-auth-crumb",
      isLogin: true,
    },
  },
  // linkedin 回调地址
  {
    path: "/linkedin/authResponse",
    name: "LinkedinAuthResponse",
    component: () => import("@/components/PlatformPagesSelect/LinkedinAuthResponse.vue"),
    meta: {
      title: "route.linkedin-auth",
      crumbs: "route.linkedin-auth-crumb",
      isLogin: true,
    },
  },
  {
    // Shoplazza 回调页不展示内容，只处理参数、通知授权来源窗口并自动关闭。
    path: "/shoplazza-callback",
    name: "shoplazzaCallback",
    component: () => import("@/components/PlatformPagesSelect/ShoplazzaAuthCallback.vue"),
    meta: {
      isLogin: true,
    },
  },
];
export default routesCommon;
